var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleTfi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xxxhdpi/TFI check_blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Driver-Details---summary-(identified)",
    transform: "translate(-576.000000, -1083.000000)",
    fill: "#002C56",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(86.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LPR-and-OCR-results"
  }, /*#__PURE__*/React.createElement("g", {
    id: "override",
    transform: "translate(376.000000, 667.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "captured-photos",
    transform: "translate(114.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.984,125.616 L16.984,116.616 L15.568,115.152 L7.984,122.76 L4.432,119.184 L3.016,120.6 L7.984,125.616 Z M10,110.616 C11.8240091,110.616 13.5119922,111.071995 15.064,111.984 C16.5680075,112.848004 17.7519957,114.031992 18.616,115.536 C19.5280046,117.088008 19.984,118.775991 19.984,120.6 C19.984,122.424009 19.5280046,124.111992 18.616,125.664 C17.7519957,127.168008 16.5680075,128.351996 15.064,129.216 C13.5119922,130.128005 11.8240091,130.584 10,130.584 C8.17599088,130.584 6.48800776,130.128005 4.936,129.216 C3.43199248,128.335996 2.24800432,127.144008 1.384,125.64 C0.47199544,124.087992 0.016,122.408009 0.016,120.6 C0.016,118.791991 0.47199544,117.112008 1.384,115.56 C2.2640044,114.055992 3.45599248,112.864004 4.96,111.984 C6.51200776,111.071995 8.19199096,110.616 10,110.616 Z",
    id: "TFI-check_blue"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleTfi);
export default __webpack_public_path__ + "static/media/check_circle_tfi.02ab3c94d7c7dfd50ca98fb23af0bbd9.svg";
export { ForwardRef as ReactComponent };